var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-ui"},[_c('m-nav-toggle'),_vm._v(" "),_c('ul',{staticClass:"navigation mb-0",class:{open:_vm.data.navbar.navActive === 'isNavbar'}},_vm._l((_vm.items),function(item,index){return _c('m-nav-item',{key:index,attrs:{"external":item.external,"path":item.path,"text":item.text}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fbeba5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/navbar/navbar.vue
// module id = null
// module chunks = 